(function () {
  'use strict';
  if (window.__junisPurchasableLoaded) return;
  window.__junisPurchasableLoaded = true;

  var CHUNK = 250;
  var cache = new Map(); // sku -> purchasable(boolean)

  function cardOf(probe) {
    return probe.closest('product-card, .product-card, .card, li[data-product-id]');
  }
  function applyOne(probe, purchasable) {
    var card = cardOf(probe);
    if (!card) return;
    if (purchasable === false) {
      card.setAttribute('data-purchasable', 'false');
      card.querySelectorAll('.quick-add, quick-add-component').forEach(function (q) {
        q.style.display = 'none';
        q.setAttribute('aria-hidden', 'true');
      });
    }
  }

  async function fetchPurchasable(skus) {
    for (var i = 0; i < skus.length; i += CHUNK) {
      var chunk = skus.slice(i, i + CHUNK);
      try {
        var locQs = window.__junisCompanyLocationId
          ? '&companyLocationId=' + encodeURIComponent(window.__junisCompanyLocationId) : '';
        var resp = await (window.junisFetch || fetch)(
          '/apps/wishtrade/stock?skus=' + encodeURIComponent(chunk.join(',')) + locQs,
          { headers: { Accept: 'application/json' } });
        if (!resp.ok) continue;
        var data = await resp.json();
        if (!data || !Array.isArray(data.stock)) continue;
        data.stock.forEach(function (s) { if (s && s.sku) cache.set(s.sku, s.purchasable !== false); });
      } catch (e) { /* 표시 보조라 실패 시 무시 — 서버 backstop이 최종 차단 */ }
    }
  }

  async function hydrate() {
    var probes = [].slice.call(document.querySelectorAll('[data-junis-purchasable-probe]:not([data-junis-done])'));
    if (!probes.length) return;
    probes.forEach(function (p) { p.setAttribute('data-junis-done', '1'); });
    var need = [];
    probes.forEach(function (p) { var sku = p.dataset.sku; if (sku && !cache.has(sku)) need.push(sku); });
    if (need.length) await fetchPurchasable(Array.from(new Set(need)));
    probes.forEach(function (p) { applyOne(p, cache.get(p.dataset.sku)); });
  }

  function init() {
    hydrate();
    document.addEventListener('junis:cards-added', hydrate); // /search 동적 주입
    try {
      var mo = new MutationObserver(function () { hydrate(); });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* MutationObserver 미지원 환경 무시 — DOMContentLoaded 폴백이 hydrate 처리 */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }
})();
